import React, { useEffect, useState } from "react";
import "./next-project.css";

const NextProject = ({ projectCaseStudy }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [studies, setStudies] = useState([]);

  useEffect(() => {
    if (!projectCaseStudy) return;

    const consolidatedStudies = [];

    // 1. Primary Case Study from existing Built-in Fields (100% Backward Compatible)
    if (
      projectCaseStudy.challenge ||
      projectCaseStudy.solution ||
      projectCaseStudy.results
    ) {
      consolidatedStudies.push({
        title: projectCaseStudy.projectName
          ? `${projectCaseStudy.projectName} Overview`
          : "Primary Case Study",
        challenge: projectCaseStudy.challenge || "No details available.",
        solution: projectCaseStudy.solution || "No details available.",
        results: projectCaseStudy.results || "No details available.",
      });
    }

    // 2. Additional Linked Case Studies from WordPress ACM / Relationship Fields
    const linkedStudies = projectCaseStudy?.caseStudiesData?.nodes || [];
    linkedStudies.forEach((item, index) => {
      if (item.challenge || item.solution || item.results || item.caseStudyTitle) {
        consolidatedStudies.push({
          title: item.caseStudyTitle || `Case Study 0${index + 2}`,
          challenge: item.challenge || "No challenge details available.",
          solution: item.solution || "No solution details available.",
          results: item.results || "No results details available.",
        });
      }
    });

    setStudies(consolidatedStudies);
  }, [projectCaseStudy]);

  if (!studies || studies.length === 0) return null;

  const currentStudy = studies[activeTab] || studies[0];

  return (
    <section className="next-prog section-padding case-studies-section">
      <div className="container" id="custom-cards">
        
        {/* Sleek Header */}
        <h2 className="pb-3 mb-4 border-bottom font-weight-bold section-title-case">
          Case Studies
        </h2>

        {/* Interactive Pill Switcher (Only appears when there are multiple case studies) */}
        {studies.length > 1 && (
          <div className="case-study-switcher">
            {studies.map((study, idx) => {
              const isSelected = activeTab === idx;
              return (
                <button
                  key={idx}
                  onClick={() => setActiveTab(idx)}
                  className={`pill-tab-btn ${
                    isSelected ? "active-pill" : ""
                  }`}
                >
                  <span className="tab-number-badge">
                    {idx + 1 < 10 ? `0${idx + 1}` : `${idx + 1}`}
                  </span>
                  <span>{study.title}</span>
                </button>
              );
            })}
          </div>
        )}

        {/* Illuminated Three-Column Showcase Grid */}
        <div key={activeTab} className="row align-items-stretch animated-content">
          
          {/* Challenge Card */}
          <div className="col-lg-4 col-md-6 col-12 card-col">
            <div className="card card-cover h-100 overflow-hidden rounded-4 shadow-lg item-box case-study-card">
              <div className="d-flex flex-column h-100 card-content-padding text-shadow-1">
                <h3 className="mb-4 font-weight-bold card-title-case">
                  Challenge
                </h3>
                <p className="card-text-content mb-0">
                  {currentStudy.challenge}
                </p>
              </div>
            </div>
          </div>

          {/* Solution Card */}
          <div className="col-lg-4 col-md-6 col-12 card-col">
            <div className="card card-cover h-100 overflow-hidden rounded-4 shadow-lg item-box case-study-card">
              <div className="d-flex flex-column h-100 card-content-padding text-shadow-1">
                <h3 className="mb-4 font-weight-bold card-title-case">
                  Solution
                </h3>
                <p className="card-text-content mb-0">
                  {currentStudy.solution}
                </p>
              </div>
            </div>
          </div>

          {/* Results Card */}
          <div className="col-lg-4 col-md-6 col-12 card-col">
            <div className="card card-cover h-100 overflow-hidden rounded-4 shadow-lg item-box case-study-card">
              <div className="d-flex flex-column h-100 card-content-padding text-shadow-1">
                <h3 className="mb-4 font-weight-bold card-title-case">
                  Results
                </h3>
                <p className="card-text-content mb-0">
                  {currentStudy.results}
                </p>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default NextProject;
